export function makeChildRoute(descendantPath = '', root?: string) {
	let newRoot = `${root ?? window.location.pathname}`
	if (!newRoot.endsWith('/')) newRoot += '/'
	const route = `${newRoot}${descendantPath}`
	return route
}
